import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { Uploader } from "../custom/uploader";
import UploadIcon from "../../assets/svgs/common/upload.svg";

type FormInputProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label: string;
	onClick: () => void;
	onValueChange: (files: File[]) => void;
};

export const FormProfileImageUpload = <T extends FieldValues>({
	form,
	name,
	label,
	onClick,
	onValueChange,
}: FormInputProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormControl>
						{field.value && field.value.length > 0 ? (
							<div className="flex items-center gap-4">
								<div className="flex justify-center items-center bg-tertiarybuttonbg border border-border border-dashed rounded-xl w-24 h-24 cursor-pointer">
									<img
										src={URL.createObjectURL(field.value[0])}
										alt="profile"
										className="rounded-xl w-24 h-24 object-cover"
									/>
								</div>
								<div className="flex flex-col gap-1 font-semibold">
									<FormLabel className="flex items-center gap-1 font-semibold text-lg">
										{field.value[0].name}
									</FormLabel>
									{/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
									<span onClick={onClick} className="text-base text-secondary cursor-pointer">
										Remove{" "}
									</span>
								</div>
							</div>
						) : (
							<Uploader
								value={field.value}
								onValueChange={onValueChange} // Using the onValueChange handler from props
								multiple={false}
								accept={{
									"image/jpg": [],
									"image/jpeg": [],
									"image/png": [],
								}}
								maxFiles={1}
								maxSize={5 * 1024 * 1024}
								className="flex items-center gap-4"
							>
								<div className="flex justify-center items-center bg-tertiarybuttonbg border border-border border-dashed rounded-xl w-24 h-24 cursor-pointer">
									<UploadIcon />
								</div>
								<div className="flex flex-col gap-1 font-semibold">
									<FormLabel className="flex items-center gap-1 font-semibold text-lg">
										{label}
									</FormLabel>
									<span className="text-base text-secondary">
										Image must be under 5MB{" "}
									</span>
								</div>
							</Uploader>
						)}
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
